import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseSepaPaymentFailedTemplates = [
  {
    id: '-135001',
    language: Language.EN,
    subject: 'Your direct debit payment failed',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PAYMENT_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>The direct debit of <strong>{{totalAmount}} €</strong> for the lease at <strong>{{getLeaseMainAddress lease}}</strong> could not be collected{{#if sepaFailureReason}} (reason: {{sepaFailureReason}}){{/if}}.</p>
        <p>Please pay the amount manually as soon as possible using the details below:</p>
        <ul><li>Account number held by {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Amount: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Remittance information: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-135002',
    language: Language.FR,
    subject: 'Votre prélèvement automatique a échoué',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PAYMENT_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Le prélèvement automatique de <strong>{{totalAmount}} €</strong> pour le bail sis <strong>{{getLeaseMainAddress lease}}</strong> n'a pas pu être effectué{{#if sepaFailureReason}} (motif : {{sepaFailureReason}}){{/if}}.</p>
        <p>Veuillez payer le montant manuellement dans les meilleurs délais à l'aide des informations ci-dessous :</p>
        <ul><li>Numéro de compte au nom de {{getBankAccountHolder bankAccount}} : <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Montant : <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Communication : <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
    `,
  },
  {
    id: '-135003',
    language: Language.NL,
    subject: 'Uw domiciliëring is mislukt',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PAYMENT_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>De domiciliëring van <strong>{{totalAmount}} €</strong> voor de huurovereenkomst op <strong>{{getLeaseMainAddress lease}}</strong> kon niet worden geïnd{{#if sepaFailureReason}} (reden: {{sepaFailureReason}}){{/if}}.</p>
        <p>Gelieve het bedrag zo spoedig mogelijk handmatig te betalen met de onderstaande gegevens:</p>
        <ul><li>Rekeningnummer bij {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Bedrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Mededeling: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-135004',
    language: Language.DE,
    subject: 'Ihre Lastschriftzahlung ist fehlgeschlagen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_PAYMENT_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Die Lastschrift über <strong>{{totalAmount}} €</strong> für den Mietvertrag unter <strong>{{getLeaseMainAddress lease}}</strong> konnte nicht eingezogen werden{{#if sepaFailureReason}} (Grund: {{sepaFailureReason}}){{/if}}.</p>
        <p>Bitte zahlen Sie den Betrag so bald wie möglich manuell mit den folgenden Angaben:</p>
        <ul><li>Kontonummer bei {{getBankAccountHolder bankAccount}}: <strong>{{lease.bankAccount.number}}</strong></li>
        <li>Betrag: <strong>{{totalAmount}} €</strong></li>
        {{#if (hasRemittanceInformation lease)}}
        <li>Verwendungszweck: <strong>{{formatPaymentCommunication lease.remittanceInformation}}</strong></li>
        {{/if}}
        </ul>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
